import { NonTextWidgetTag } from 'modules/Editor/components/AccessibilityManager/AccessibilityManager.types';
import { TextWidgetExceptionTag, TextWidgetTag } from 'widgets/TextBasedWidgets/common/TextBasedWidgets.types';

export const DEFAULT_NON_TEXT_TAGS = [NonTextWidgetTag.MissingAlt, NonTextWidgetTag.Alt];

export const TAGS_TO_LABEL = {
  [TextWidgetTag.Paragraph]: 'P',
  [TextWidgetTag.H1]: 'H1',
  [TextWidgetTag.H2]: 'H2',
  [TextWidgetTag.H3]: 'H3',
  [TextWidgetTag.H4]: 'H4',
  [TextWidgetTag.H5]: 'H5',
  [TextWidgetTag.H6]: 'H6',
  [TextWidgetExceptionTag.Figure]: 'Figure',
  [NonTextWidgetTag.MissingAlt]: 'ALT',
  [NonTextWidgetTag.Alt]: 'ALT',
};
